const duplicateSlashPattern = /([^:])\/{2,}/gi;

export const joinURL = (...parts: Array<string>): string =>
  parts
    .join('/')
    .replace(duplicateSlashPattern, '$1/')
    .replace(/^\/{2,}/gi, '/');
